import { Component } from '@angular/core';
import { ResourceService } from 'sce-core';
import { SearchableEntityConfig } from '../../../../shared/models/searchable-entity-config';
import { DetailedEntityBackendService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { DetailedEntityDataEditorService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { MaintainReportButtonService } from '../services/maintain-report-button.service';
import { MaintainReportDataService } from '../services/maintain-report-data.service';
import { DetailedEntityActionService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-action.service';

@Component({
  selector: 'lfwms-maintain-report-home',
  templateUrl: './maintain-report-home.component.html',
  styleUrls: ['./maintain-report-home.component.css'],
  providers: [ MaintainReportDataService,
    DetailedEntityActionService,
    DetailedEntityBackendService,
    DetailedEntityDataEditorService,
    MaintainReportButtonService
   ]
})
export class MaintainReportHomeComponent {
  constructor(protected resourceService: ResourceService, protected dataService: MaintainReportDataService,
    protected buttonService: MaintainReportButtonService) {
    dataService.initializeEntityConfiguration(this.createEntityConfig());
    dataService.initializePrimarySearchContext();
  }

  protected createEntityConfig(): SearchableEntityConfig {
    const entityConfig = new SearchableEntityConfig('Maintain Report');
    entityConfig.setPageTitle(this.resourceService.get('mn_maintain_report'));
    entityConfig.setItemLabel(this.resourceService.get('mn_maintain_report'));
    entityConfig.setBreadCrumbPrefix('Maintain Report #');
    entityConfig.initializePrimarySearchForTableId('maintainreportstd', 'rpt_id');
    entityConfig.initializeDetailSearchForTableId('maintainrprtsparmstd', 'parm_no');
    entityConfig.setSearchPageRoute('/home/reports/maintain-report/search');
    entityConfig.setDetailPageRoute('/home/reports/maintain-report/details');
    entityConfig.setUseAdvancedTable(true);
    entityConfig.initializeConfigForTemplate1();
    entityConfig.getPrimarySearchParams().autoGenerateIdProperty = false;
    return entityConfig;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-home.component.ts